<div *ngIf="show" class="loading-overlay">
    <div class="card d-flex justify-content-between flex-row p-4 align-items-center">
        <div class="w-25 p-2 me-4 d-flex justify-content-center align-items-center">
            <div class="loading-spinner"></div>
        </div>
        <div class="vr"></div>
        <div class="w-75 p-4 d-flex justify-content-center flex-column align-items-center text-center">
            <h6>Por favor, aguarde.</h6>
            <p>Estamos processando sua solicitação.</p>
        </div>
    </div>
</div>